// extracted by mini-css-extract-plugin
export default {"bubbleIcon":"AlertContainer_bubbleIcon__-uV0K"};